'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import { Tab, TabList, TabPanel, TabPanelProps, TabProps, Tabs } from 'react-aria-components';
import styles from '../tab-container-block.module.scss';
export type ContentTabData = {
  tabContent: ReactElement[];
  tabId: string;
  tabName: string;
};
export type ContentTabProps = {
  tabs: ContentTabData[];
};
export const ContentTabs = t0 => {
  const $ = _c(9);
  const {
    tabs
  } = t0;
  let t1;
  if ($[0] !== tabs) {
    t1 = tabs.map(_temp);
    $[0] = tabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <TabList className={styles["nav-menu"]}>{t1}</TabList>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== tabs) {
    t3 = tabs.map(_temp2);
    $[4] = tabs;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Tabs>{t2}{t3}</Tabs>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(tab) {
  return <Tab className={styles.tab} id={tab.tabId} key={`tab-${tab.tabId}`}>{tab.tabName}</Tab>;
}
function _temp2(tab_0) {
  return <TabPanel id={tab_0.tabId} key={`tab-content-${tab_0.tabId}`}>{tab_0.tabContent}</TabPanel>;
}